import React from "react";
import "./ModalEditWindow.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { closeRequestModal, openRequestModal } from "../../actions/modals";
import EnrollChild from "./modalComponents/EnrollChild";
import ChooseCity from "./modalComponents/ChooseCity";
import CallBackComponent from "./modalComponents/CallBack";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

class ModalEditWindow extends React.Component {
  switсher = (type, data) => {
    let result = null;
    switch (type) {
      case "CallBack":
        result = <CallBackComponent data={data} />;
        break;
      case "ChooseCity":
        result = <ChooseCity data={data} />;
        break;
      case "EnrollChild":
        result = <EnrollChild data={data} />;
        break;
      default:
        break;
    }
    return result;
  };

  closeModalHandler = () => {
    this.props.closeRequestModal();
    setTimeout(() => {
      if (!this.props.defaultCity) {
        this.props.openRequestModal({
          opened: true,
          data: {
            header: "Оберiть мiсто",
            modaltype: "ChooseCity",
          },
        });
      }
    }, 1000);
  };

  render() {
    let switchType = this.props.requestmodal.data
      ? this.props.requestmodal.data.modaltype
      : "default";

    const data = this.props.requestmodal.data;
    const switcherSchema = {
      ChooseCity: "lg",
    };
    return (
      <Dialog
        fullWidth={true}
        maxWidth={switcherSchema[switchType] || "xs"}
        open={this.props.requestmodal.opened || false}
        aria-labelledby="responsive-dialog-title"
        onClose={this.closeModalHandler}
      >
        <DialogTitle>
          {this.props.requestmodal.opened &&
            this.props.requestmodal.data.header}
          <IconButton
            id="close_modal-button"
            aria-label="close"
            onClick={this.closeModalHandler}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>{this.switсher(switchType, data)}</DialogContent>
      </Dialog>
    );
  }
}

const widthConnect = connect(
  (state) => ({
    requestmodal: state.modalWindow.requestmodal,
    modal: state.modalWindow,
    defaultCity: state.cities && state.cities.defaultCity,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        closeRequestModal,
        openRequestModal,
      },
      dispatch
    )
);

export default widthConnect(ModalEditWindow);
